export enum ICON_TYPE {
  CARET_RIGHT = 'CARET_RIGHT',
  CARET_LEFT = 'CARET_LEFT',
  SEARCH = 'SEARCH',
  SEARCH2 = 'SEARCH2',
}
